import React, {Component} from 'react'
import {subTimeStr,subStr} from "../../utills/subStringUtill";
import {message, Modal, Form, DatePicker,Popconfirm} from 'antd'

const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}

/**
 * 物流轨迹详情
 * @param e
 */
 export function elhtMala(_this, action, getFieldDecorator, processShow){ //目的地 马拉舍维奇 转关地 马拉舍维奇 出口口岸 二连浩特 
    return  <div className={processShow ? "processBox processShow":'processBox'}>
                    <Modal
                        title="轨迹编辑"
                        visible={_this.state.visible}
                        onOk={_this.handleOk}
                        onCancel={_this.handleCancel}>
                        <Form {...formItemLayout}>
                            <Form.Item label="时间">
                                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
                            </Form.Item>
                        </Form>
                    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达二连浩特(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZamynUud',_this.state.arriveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎门乌德</div>
                    <div className="time1">{_this.state.arriveZamynUudDt ? subStr(_this.state.arriveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.arriveZamynUudDt ? subTimeStr(_this.state.arriveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveZamynUud',_this.state.leaveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎门乌德出发</div>
                    <div className="time1">{_this.state.leaveZamynUudDt ? subStr(_this.state.leaveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.leaveZamynUudDt ? subTimeStr(_this.state.leaveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskMala(_this, action, getFieldDecorator, processShow){ //目的地 马拉舍维奇 转关地 马拉舍维奇 出口口岸 阿拉山口 
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlMala(_this, action, getFieldDecorator, processShow){ //目的地 马拉舍维奇 转关地 马拉舍维奇 出口口岸 满洲里 
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function elhtDuisburg(_this, action, getFieldDecorator, processShow){ //目的地 杜伊斯堡 转关地 杜伊斯堡 出口口岸 二连浩特
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal> 
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达二连浩特(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZamynUud',_this.state.arriveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎门乌德</div>
                    <div className="time1">{_this.state.arriveZamynUudDt ? subStr(_this.state.arriveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.arriveZamynUudDt ? subTimeStr(_this.state.arriveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveZamynUud',_this.state.leaveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎门乌德出发</div>
                    <div className="time1">{_this.state.leaveZamynUudDt ? subStr(_this.state.leaveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.leaveZamynUudDt ? subTimeStr(_this.state.leaveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveMala',_this.state.leaveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">马拉舍维奇出发</div>
                    <div className="time1">{_this.state.leaveMalaDt ? subStr(_this.state.leaveMalaDt) :''}</div>
                    <div className="time2">{_this.state.leaveMalaDt ? subTimeStr(_this.state.leaveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达杜伊斯堡（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskDuisburg(_this, action, getFieldDecorator, processShow){ //目的地 杜伊斯堡 转关地 杜伊斯堡 出口口岸 阿拉山口
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveMala',_this.state.leaveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">马拉舍维奇出发</div>
                    <div className="time1">{_this.state.leaveMalaDt ? subStr(_this.state.leaveMalaDt) :''}</div>
                    <div className="time2">{_this.state.leaveMalaDt ? subTimeStr(_this.state.leaveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达杜伊斯堡（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlDuisburg(_this, action, getFieldDecorator, processShow){ //目的地 杜伊斯堡 转关地 杜伊斯堡 出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal> 
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达杜伊斯堡（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function elhtHamburg(_this, action, getFieldDecorator, processShow){ //目的地 汉堡 转关地 汉堡 出口口岸 二连浩特
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal> 
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达二连浩特(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZamynUud',_this.state.arriveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎门乌德</div>
                    <div className="time1">{_this.state.arriveZamynUudDt ? subStr(_this.state.arriveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.arriveZamynUudDt ? subTimeStr(_this.state.arriveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveZamynUud',_this.state.leaveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎门乌德出发</div>
                    <div className="time1">{_this.state.leaveZamynUudDt ? subStr(_this.state.leaveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.leaveZamynUudDt ? subTimeStr(_this.state.leaveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveMala',_this.state.leaveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">马拉舍维奇出发</div>
                    <div className="time1">{_this.state.leaveMalaDt ? subStr(_this.state.leaveMalaDt) :''}</div>
                    <div className="time2">{_this.state.leaveMalaDt ? subTimeStr(_this.state.leaveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达汉堡（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskHamburg(_this, action, getFieldDecorator, processShow){ //目的地 汉堡 转关地 汉堡 出口口岸 阿拉山口
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveMala',_this.state.leaveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">马拉舍维奇出发</div>
                    <div className="time1">{_this.state.leaveMalaDt ? subStr(_this.state.leaveMalaDt) :''}</div>
                    <div className="time2">{_this.state.leaveMalaDt ? subTimeStr(_this.state.leaveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达汉堡（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlHamburg(_this, action, getFieldDecorator, processShow){ //目的地 汉堡 转关地 汉堡 出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达汉堡（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskQpBdps(_this, action, getFieldDecorator, processShow){ //目的地 布达佩斯 转关地 扎霍尼 出口口岸 阿拉山口（乔普线）
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveQiaopuDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveQiaopu',_this.state.arriveQiaopuDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达乔普</div>
                    <div className="time1">{_this.state.arriveQiaopuDt ? subStr(_this.state.arriveQiaopuDt) :''}</div>
                    <div className="time2">{_this.state.arriveQiaopuDt ? subTimeStr(_this.state.arriveQiaopuDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZahonyDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZahony',_this.state.arriveZahonyDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎霍尼</div>
                    <div className="time1">{_this.state.arriveZahonyDt ? subStr(_this.state.arriveZahonyDt) :''}</div>
                    <div className="time2">{_this.state.arriveZahonyDt ? subTimeStr(_this.state.arriveZahonyDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZahonyDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('leaveZahony',_this.state.leaveZahonyDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎霍尼出发</div>
                    <div className="time1">{_this.state.leaveZahonyDt ? subStr(_this.state.leaveZahonyDt) :''}</div>
                    <div className="time2">{_this.state.leaveZahonyDt ? subTimeStr(_this.state.leaveZahonyDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布达佩斯（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskMaLaBdps(_this, action, getFieldDecorator, processShow){ //目的地 布达佩斯 转关地 扎霍尼 出口口岸 阿拉山口（马拉线）
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestCTDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrestCT',_this.state.arriveBrestCTDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特中心站</div>
                    <div className="time1">{_this.state.arriveBrestCTDt ? subStr(_this.state.arriveBrestCTDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestCTDt ? subTimeStr(_this.state.arriveBrestCTDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZahonyDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZahony',_this.state.arriveZahonyDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎霍尼</div>
                    <div className="time1">{_this.state.arriveZahonyDt ? subStr(_this.state.arriveZahonyDt) :''}</div>
                    <div className="time2">{_this.state.arriveZahonyDt ? subTimeStr(_this.state.arriveZahonyDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZahonyDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('leaveZahony',_this.state.leaveZahonyDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎霍尼出发</div>
                    <div className="time1">{_this.state.leaveZahonyDt ? subStr(_this.state.leaveZahonyDt) :''}</div>
                    <div className="time2">{_this.state.leaveZahonyDt ? subTimeStr(_this.state.leaveZahonyDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布达佩斯（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlBdps(_this, action, getFieldDecorator, processShow){ //目的地 布达佩斯 转关地 扎霍尼 出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestCTDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrestCT',_this.state.arriveBrestCTDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特中心站</div>
                    <div className="time1">{_this.state.arriveBrestCTDt ? subStr(_this.state.arriveBrestCTDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestCTDt ? subTimeStr(_this.state.arriveBrestCTDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZahonyDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZahony',_this.state.arriveZahonyDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎霍尼</div>
                    <div className="time1">{_this.state.arriveZahonyDt ? subStr(_this.state.arriveZahonyDt) :''}</div>
                    <div className="time2">{_this.state.arriveZahonyDt ? subTimeStr(_this.state.arriveZahonyDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZahonyDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('leaveZahony',_this.state.leaveZahonyDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎霍尼出发</div>
                    <div className="time1">{_this.state.leaveZahonyDt ? subStr(_this.state.leaveZahonyDt) :''}</div>
                    <div className="time2">{_this.state.leaveZahonyDt ? subTimeStr(_this.state.leaveZahonyDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布达佩斯（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function hegsHegs(_this, action, getFieldDecorator, processShow){ //目的地 --- 转关地 霍尔果斯 出口口岸 霍尔果斯
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达霍尔果斯(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAtenkoriDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arriveAtenkori', _this.state.arriveAtenkoriDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿腾科里</div>
                    <div className="time1">{_this.state.arriveAtenkoriDt ? subStr(_this.state.arriveAtenkoriDt) :''}</div>
                    <div className="time2">{_this.state.arriveAtenkoriDt ? subTimeStr(_this.state.arriveAtenkoriDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAtenkoriDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('leaveAtenkori', _this.state.leaveAtenkoriDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">阿腾科里出发</div>
                    <div className="time1">{_this.state.leaveAtenkoriDt ? subStr(_this.state.leaveAtenkoriDt) :''}</div>
                    <div className="time2">{_this.state.leaveAtenkoriDt ? subTimeStr(_this.state.leaveAtenkoriDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">抵达目的地</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mhWx(_this, action, getFieldDecorator, processShow){ //目的地 老挝 万象 转关地 老挝 万象 出口口岸 磨憨
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达磨憨(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBotenDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arriveBoten', _this.state.arriveBotenDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达磨丁</div>
                    <div className="time1">{_this.state.arriveBotenDt ? subStr(_this.state.arriveBotenDt) :''}</div>
                    <div className="time2">{_this.state.arriveBotenDt ? subTimeStr(_this.state.arriveBotenDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达万象（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function elhtWexn(_this, action, getFieldDecorator, processShow){ //目的地 俄罗斯 沃尔西诺 转关地 俄罗斯 沃尔西诺 出口口岸 二连浩特
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达二连浩特(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arriveZamynUud', _this.state.arriveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎门乌德</div>
                    <div className="time1">{_this.state.arriveZamynUudDt ? subStr(_this.state.arriveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.arriveZamynUudDt ? subTimeStr(_this.state.arriveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arriveKartalare', _this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达沃尔西诺（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskWexn(_this, action, getFieldDecorator, processShow){ //目的地 俄罗斯 沃尔西诺 转关地 俄罗斯 沃尔西诺 出口口岸 阿拉山口
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达沃尔西诺（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlWexn(_this, action, getFieldDecorator, processShow){ //目的地 俄罗斯 沃尔西诺 转关地 俄罗斯 沃尔西诺 出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arriveKartalare', _this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达沃尔西诺（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlHs(_this, action, getFieldDecorator, processShow){ //目的地 波兰 华沙 转关地 波兰 华沙 出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达华沙（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskHs(_this, action, getFieldDecorator, processShow){ //目的地 波兰 华沙 转关地 波兰 华沙 出口口岸 阿拉山口
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('collect',_this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arrive',_this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('declare',_this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() =>_this.editDate('pass',_this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('transport',_this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('destination',_this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达华沙（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskXlyjn(_this, action, getFieldDecorator, processShow){ //目的地 谢利亚季诺 转关地 谢利亚季诺  出口口岸 阿拉山口
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveKartalare',_this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达谢利亚季诺（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function elhtXlyjn(_this, action, getFieldDecorator, processShow){ //目的地 谢利亚季诺 转关地 谢利亚季诺  出口口岸 二连浩特
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达二连浩特(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZamynUud',_this.state.arriveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎门乌德</div>
                    <div className="time1">{_this.state.arriveZamynUudDt ? subStr(_this.state.arriveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.arriveZamynUudDt ? subTimeStr(_this.state.arriveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveZamynUud',_this.state.leaveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎门乌德出发</div>
                    <div className="time1">{_this.state.leaveZamynUudDt ? subStr(_this.state.leaveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.leaveZamynUudDt ? subTimeStr(_this.state.leaveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveKartalare',_this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达谢利亚季诺（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlXlyjn(_this, action, getFieldDecorator, processShow){ //目的地 谢利亚季诺 转关地 谢利亚季诺  出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveKartalare',_this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达谢利亚季诺（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskPlysd(_this, action, getFieldDecorator, processShow){ //目的地 谢利亚季诺 转关地 普洛耶什蒂  出口口岸 阿拉山口
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAradDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveArad',_this.state.arriveAradDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉德</div>
                    <div className="time1">{_this.state.arriveAradDt ? subStr(_this.state.arriveAradDt) :''}</div>
                    <div className="time2">{_this.state.arriveAradDt ? subTimeStr(_this.state.arriveAradDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达普洛耶什蒂（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlPlysd(_this, action, getFieldDecorator, processShow){ //目的地 谢利亚季诺 转关地 普洛耶什蒂  出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveBrestDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveBrest',_this.state.arriveBrestDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达布列斯特</div>
                    <div className="time1">{_this.state.arriveBrestDt ? subStr(_this.state.arriveBrestDt) :''}</div>
                    <div className="time2">{_this.state.arriveBrestDt ? subTimeStr(_this.state.arriveBrestDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveMalaDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveMala',_this.state.arriveMalaDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达马拉舍维奇</div>
                    <div className="time1">{_this.state.arriveMalaDt ? subStr(_this.state.arriveMalaDt) :''}</div>
                    <div className="time2">{_this.state.arriveMalaDt ? subTimeStr(_this.state.arriveMalaDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAradDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveArad',_this.state.arriveAradDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉德</div>
                    <div className="time1">{_this.state.arriveAradDt ? subStr(_this.state.arriveAradDt) :''}</div>
                    <div className="time2">{_this.state.arriveAradDt ? subTimeStr(_this.state.arriveAradDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达普洛耶什蒂（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function alskAlktLwgl(_this, action, getFieldDecorator, processShow){ //目的地 埃列克特罗乌格利 转关地 埃列克特罗乌格利  出口口岸 阿拉山口
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达阿拉山口(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkArriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkArrive',_this.state.dstkArriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达多斯特克</div>
                    <div className="time1">{_this.state.dstkArriveDt ? subStr(_this.state.dstkArriveDt) :''}</div>
                    <div className="time2">{_this.state.dstkArriveDt ? subTimeStr(_this.state.dstkArriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.dstkOutDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('dstkOut',_this.state.dstkOutDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">多斯特克出发</div>
                    <div className="time1">{_this.state.dstkOutDt ? subStr(_this.state.dstkOutDt) :''}</div>
                    <div className="time2">{_this.state.dstkOutDt ? subTimeStr(_this.state.dstkOutDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveKartalare',_this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达埃列克特罗乌格利（电煤）（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function elhtAlktLwgl(_this, action, getFieldDecorator, processShow){ //目的地 埃列克特罗乌格利 转关地 埃列克特罗乌格利  出口口岸 二连浩特
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达二连浩特(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveZamynUud',_this.state.arriveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达扎门乌德</div>
                    <div className="time1">{_this.state.arriveZamynUudDt ? subStr(_this.state.arriveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.arriveZamynUudDt ? subTimeStr(_this.state.arriveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveZamynUudDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveZamynUud',_this.state.leaveZamynUudDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">扎门乌德出发</div>
                    <div className="time1">{_this.state.leaveZamynUudDt ? subStr(_this.state.leaveZamynUudDt) :''}</div>
                    <div className="time2">{_this.state.leaveZamynUudDt ? subTimeStr(_this.state.leaveZamynUudDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveKartalare',_this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达埃列克特罗乌格利（电煤）（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};

export function mzlAlktLwgl(_this, action, getFieldDecorator, processShow){ //目的地 埃列克特罗乌格利 转关地 埃列克特罗乌格利  出口口岸 满洲里
    return <div className={processShow ? "processBox processShow":'processBox'}>
    <Modal
        title="轨迹编辑"
        visible={_this.state.visible}
        onOk={_this.handleOk}
        onCancel={_this.handleCancel}>
        <Form {...formItemLayout}>
            <Form.Item label="时间">
                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
            </Form.Item>
        </Form>
    </Modal>
            <div className={_this.state.commitDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className="info">
                    <div className="circle"><i></i></div>
                    <div className="title">货运订单</div>
                    <div className="time1">{_this.state.commitDt ? subStr(_this.state.commitDt) :''}</div>
                    <div className="time2">{_this.state.commitDt ? subTimeStr(_this.state.commitDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.collectDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('collect', _this.state.collectDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">上门提货</div>
                    <div className="time1">{_this.state.collectDt? subStr(_this.state.collectDt) :''}</div>
                    <div className="time2">{_this.state.collectDt? subTimeStr(_this.state.collectDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('arrive', _this.state.arriveDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">货物到达赣州国际港</div>
                    <div className="time1">{_this.state.arriveDt ? subStr(_this.state.arriveDt) :''}</div>
                    <div className="time2">{_this.state.arriveDt ? subTimeStr(_this.state.arriveDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.declareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('declare', _this.state.declareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">报关放行</div>
                    <div className="time1">{_this.state.declareDt ? subStr(_this.state.declareDt) :''}</div>
                    <div className="time2">{_this.state.declareDt ? subTimeStr(_this.state.declareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.passDt ? 'proceIteam finish' : 'proceIteam'}>
                {action === 'edit' ?
                    <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                onConfirm={() => _this.editDate('pass', _this.state.passDt)}>
                        <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                            <div className="circle"><i></i></div>
                            <div className="title">赣州国际港站出发</div>
                            <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                            <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                        </div>
                    </Popconfirm> : <div className={action === 'edit' ? 'info itemHover' : 'info'}>
                        <div className="circle"><i></i></div>
                        <div className="title">赣州国际港站出发</div>
                        <div className="time1">{_this.state.passDt ? subStr(_this.state.passDt):''}</div>
                        <div className="time2">{_this.state.passDt ? subTimeStr(_this.state.passDt):''}</div>
                    </div>
                }
            </div>
            <div className={_this.state.transportDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('transport', _this.state.transportDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达满洲里(出境)</div>
                    <div className="time1">{_this.state.transportDt ? subStr(_this.state.transportDt) :''}</div>
                    <div className="time2">{_this.state.transportDt ? subTimeStr(_this.state.transportDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveAbaikal',_this.state.arriveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达后贝加尔</div>
                    <div className="time1">{_this.state.arriveAbaikalDt ? subStr(_this.state.arriveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.arriveAbaikalDt ? subTimeStr(_this.state.arriveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.leaveAbaikalDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('leaveAbaikal',_this.state.leaveAbaikalDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">后贝加尔出发</div>
                    <div className="time1">{_this.state.leaveAbaikalDt ? subStr(_this.state.leaveAbaikalDt) :''}</div>
                    <div className="time2">{_this.state.leaveAbaikalDt ? subTimeStr(_this.state.leaveAbaikalDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.arriveKartalareDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() =>_this.editDate('arriveKartalare',_this.state.arriveKartalareDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达卡尔塔雷</div>
                    <div className="time1">{_this.state.arriveKartalareDt ? subStr(_this.state.arriveKartalareDt) :''}</div>
                    <div className="time2">{_this.state.arriveKartalareDt ? subTimeStr(_this.state.arriveKartalareDt) :''}</div>
                </div>
            </div>
            <div className={_this.state.destinationDt ? 'proceIteam finish' : 'proceIteam'}>
                <div className={action==='edit' ?'info itemHover':'info'} onClick={() => _this.editDate('destination', _this.state.destinationDt)}>
                    <div className="circle"><i></i></div>
                    <div className="title">到达埃列克特罗乌格利（电煤）（目的地）</div>
                    <div className="time1">{_this.state.destinationDt ? subStr(_this.state.destinationDt) :''}</div>
                    <div className="time2">{_this.state.destinationDt ? subTimeStr(_this.state.destinationDt) :''}</div>
                </div>
            </div>
            <div className="processShowBtn" onClick={_this.spreadOpt}>
                <span className="open">展开</span> 
                <span className="closed">收起</span>
            </div>
        </div>
};